'use strict';

const isMotionValue = (value) => Boolean(value && value.getVelocity);

exports.isMotionValue = isMotionValue;
//# sourceMappingURL=is-motion-value.cjs.map
